import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AggregatorModel } from 'src/app/Model/Aggregator.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { ParametersModel } from 'src/app/Model/Parameter.model';
import { SalesTypeModel } from 'src/app/Model/SalesType.model';
import { BaseService } from '../Base/BaseService';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { AuthService } from '../Interceptor/auth.service';

@Injectable({
  providedIn: 'root'
})
export class crmGeoService extends BaseService {

  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) {
    super(http, lsService,authService);
    this.Component = "crmService";
  }

  public async getAgregadores(idCountry:string) {
    let Response: AggregatorModel[];
    await this.PostData(idCountry, "CrmGeoService", "Getagregadores").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async getAgregador(idCountry:string, aggregatorId: string) {
    let Response: AggregatorModel;
    let data = idCountry + '/' + aggregatorId
    await this.PostData(data, "CrmGeoService", "Getagregador").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async getIataPadre(iata:string) {
    let Response: string;
    await this.PostData(iata, "CrmGeoService", "GetIataPadre").then((res) => {
      if (res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }

  public async getEstadoAgencia(iata:string) {
    let Response: string;
    await this.PostData(iata, "CrmGeoService", "getEstadoAgencia").then((res) => {
      if (res.head.status) {
        Response = res.body.response;
      }
    });
    return Response;
  }

  public async getCity() {
    let Country: CountryModel[];
    await this.PostData("","CrmGeoService","GetCity").then((res) => {
      if(res.head.status) {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getCountries() {
    let Country: CountryModel[];
    await this.PostData("","CrmGeoService","GetCountries").then((res) => {
      if(res.head.status) {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getLanguage() {
    let Country: ParametersModel[];
    await this.PostData("","CrmGeoService","GetLanguages").then((res) => {
      if(res.head.status) {
        Country = JSON.parse(res.body.response);
      }
    });
    return Country;
  }

  public async getDocumentTypesCrm(country) {
    let DocType: DocumentTypeModel[];
    await this.PostData(country,"CrmGeoService","GetDocTypesByCountry").then((res) => {
      if(res.head.status) {
        DocType = JSON.parse(res.body.response);
      }
    });
    return DocType;
  }

  public async getSalesType() {
    let SalesType: SalesTypeModel[];
    await this.PostData("","CrmGeoService","GetSaleTypes").then((res) => {
      if(res.head.status) {
        SalesType = JSON.parse(res.body.response);
      }
    });
    return SalesType;
  }

  public async getNombresGlobales(){
    let Response: CountryModel[];
    await this.PostData("","CrmGeoService","GetNombresGlobales").then((res) => {
      if(res.head.status) {
        Response = JSON.parse(res.body.response);
      }
    });
    return Response;
  }
}
